import {
  AdminCreateLmsTraining,
  AdminDeleteLmsTraining,
  AdminFetchLmsTrainingCatalog,
  AdminUpdateLmsTraining,
} from 'src/constants/actionTypes'
import type { LmsTrainingPlain } from 'src/interfaces/collectStepReference'
import { resolveErrorMessage } from 'src/utils/sagaErrorMessage'
import { Action } from 'src/utils/reduxUtils'
import type { LmsTrainingState } from './types'

const getInitialState = (): LmsTrainingState => {
  return {
    lmsTrainings: [],
    lmsTrainingsLoading: false,
    lmsTrainingsError: null,
    saving: false,
    deletingId: null,
  }
}

export const lmsTrainingReducer = (
  state: LmsTrainingState = getInitialState(),
  action: Action<unknown>,
): LmsTrainingState => {
  switch (action.type) {
    case AdminFetchLmsTrainingCatalog.type.REQUEST:
      return {
        ...state,
        lmsTrainingsLoading: true,
        lmsTrainingsError: null,
      }
    case AdminFetchLmsTrainingCatalog.type.SUCCESS: {
      const lmsTrainings = (action.payload as LmsTrainingPlain[] | undefined) ?? []

      return {
        ...state,
        lmsTrainings,
        lmsTrainingsLoading: false,
        lmsTrainingsError: null,
      }
    }
    case AdminFetchLmsTrainingCatalog.type.FAILED:
      return {
        ...state,
        lmsTrainingsLoading: false,
        lmsTrainingsError: resolveErrorMessage(action.payload, 'Failed to load LMS courses'),
      }

    // Create, update and delete never write to `lmsTrainings` — the list is refetched on
    // success, which is the single source of truth. See the design doc's §7.
    case AdminCreateLmsTraining.type.REQUEST:
    case AdminUpdateLmsTraining.type.REQUEST:
      return {
        ...state,
        saving: true,
      }
    case AdminCreateLmsTraining.type.SUCCESS:
    case AdminCreateLmsTraining.type.FAILED:
    case AdminUpdateLmsTraining.type.SUCCESS:
    case AdminUpdateLmsTraining.type.FAILED:
      return {
        ...state,
        saving: false,
      }

    case AdminDeleteLmsTraining.type.REQUEST: {
      const payload = action.payload as { lmsTrainingId?: string } | undefined

      return {
        ...state,
        deletingId: payload?.lmsTrainingId ?? null,
      }
    }
    // Cleared on FAILED as well as SUCCESS: deleting a course used by an onboarding template
    // fails at the FK, and that must not leave the row's Delete button spinning forever.
    case AdminDeleteLmsTraining.type.SUCCESS:
    case AdminDeleteLmsTraining.type.FAILED:
      return {
        ...state,
        deletingId: null,
      }

    default:
      return state
  }
}
